import React, { useEffect, useState } from "react";
import "./../profile.css";
import AddEditMember from "./AddEditMember";
import { profileAction } from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { convertToDate, getAgeText, getUser } from "../../../constant/utils";
import moment from "moment";
import Loader from "react-loader-spinner";

const FamilyMember = () => {
  const dispatch = useDispatch();
  const USER: any = getUser();
  const [open, setOpen] = useState<boolean>(false);
  const [editData, setEditData] = useState<any>({});
  const familyMemberData: any = useSelector((state: any) =>
    state.profile.patientList ? state.profile.patientList?.[0] : {}
  );
  const commonLoading: any = useSelector((state: any) =>
    state.common.loader ? state.common.loader : false
  );
  const patientData: any = useSelector((state: any) =>
    state.profile.patientList ? state.profile.patientList?.[0] : {}
  );
  const handleOpen = (data: any) => {
    setEditData(data);
    setOpen(true);
  };

  const handleClose = () => {
    setEditData({});
    setOpen(false);
  };

  const handleDelete = (data: any) => {
    if (window.confirm("Are you want to delete ?")) {
      dispatch(
        profileAction.deleteMemberAction({
          id: data?.id,
          pid: patientData?.pid,
        })
      );
    }
  };

  const handleSubmit = (data: any) => {
    let newData = {
      ...data,
      dob: convertToDate(data?.dob),
    };
    if (editData?.pid || editData?.id) {
      if (editData?.pid && editData?.family) {
        dispatch(
          profileAction.updatePatientAction(
            { ...newData, pid: editData?.pid },
            () => onSuccessAddMember()
          )
        );
      } else {
        dispatch(
          profileAction.updateFamilyMemberAction(
            { ...newData, id: editData?.id},
            () => onSuccessAddMember()
          )
        );
      }
    } else {
      if (patientData?.pid) {
        dispatch(
          profileAction.addFamilyMemberAction(
           newData,
            () => onSuccessAddMember()
          )
        );
      } else {
        dispatch(
          profileAction.createPatientAction(newData, () => {
            dispatch(
              profileAction.addFamilyMemberAction(
                newData,
                () => onSuccessAddMember()
              )
            );
            setOpen(false);
          })
        );
      }
    }
  };
  function onSuccessAddMember() {
    setEditData({});
    setOpen(false);
  }

  return (
    <React.Fragment>
      <div className="tc_box">
        <div className="heading_box">
          <div className="row justify-content-between">
            <span className="col">Family Members</span>
            <a
              href=""
              className="book--hexagon add_acc"
              onClick={(e: any) => {
                e.preventDefault();
                handleOpen({});
              }}
            >
              <span>
                <img
                  className="mr-2"
                  src="/assets/img/my-profile/plus.png"
                  aria-hidden="true"
                  width={16}
                  height={16}
                />
                Add New Member
              </span>
            </a>
          </div>
        </div>
        {commonLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loader type="ThreeDots" color="#fff" height={100} width={100} />
            </div>
          ) : (
        <div className="address_box_list">
          {familyMemberData?.pid ? (
            <div className="address_box">
              <div className="member_details">
                <img src="/assets/img/my-profile/user_pic.png" alt="" />
                <div>
                  <h6>
                    {familyMemberData?.first_name} {familyMemberData?.last_name}
                  </h6>
                  <p>
                    {familyMemberData?.mobile_no
                      ? `+91-${familyMemberData?.mobile_no || ""}`
                      : ""}
                  </p>
                  <p>{`${familyMemberData?.gender || ""}, ${getAgeText(
                    familyMemberData?.dob
                  )}`}</p>
                  <p>{familyMemberData?.relation_txt}</p>
                </div>
              </div>
              <div className="d-flex flex-column  justify-content-end aling-items-end">
                <div className="text-right">
                  <img
                    src="assets/img/my-profile/edit.png"
                    alt=""
                    className="cursor-pointer scale_picon"
                    onClick={(e: any) => {
                      handleOpen(familyMemberData);
                    }}
                  />
                  {/* <img
                  src="assets/img/my-profile/delete.png"
                  alt=""
                  className="cursor-pointer scale_picon ml-3"
                  onClick={(e: any) => {
                    handleDelete(familyMemberData);
                  }}
                /> */}
                </div>
              </div>
            </div>
          ) : 
          <div className="address_box">
            <p className="text-center w-100 font-weight-bold">No record found, please add a new memeber.</p>
          </div>
          }
          {familyMemberData?.family &&
            familyMemberData?.family?.length > 0 &&
            familyMemberData?.family?.map((member: any) => (
              <div className="address_box" key={member?.id}>
                <div className="member_details">
                  <img src="/assets/img/my-profile/user_pic.png" alt="" />
                  <div>
                    <h6>
                      {member?.first_name} {member?.last_name}
                    </h6>
                    <p>
                      {member?.mobile_no
                        ? `+91-${member?.mobile_no || ""}`
                        : ""}
                    </p>
                    <p>{`${member?.gender || ""}, ${getAgeText(
                      member?.dob
                    )}`}</p>
                    <p>{member?.relation_txt}</p>
                  </div>
                </div>
                <div className="d-flex flex-column  justify-content-end aling-items-end">
                  <div className="text-right">
                    <img
                      src="assets/img/my-profile/edit.png"
                      alt=""
                      className="cursor-pointer scale_picon"
                      onClick={(e: any) => {
                        handleOpen(member);
                      }}
                    />
                    <img
                      src="assets/img/my-profile/delete.png"
                      alt=""
                      className="cursor-pointer scale_picon ml-3"
                      onClick={(e: any) => {
                        handleDelete(member);
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
          )}
      </div>
      {open && (
        <AddEditMember
          open={open}
          editData={editData}
          handleClose={handleClose}
          handleSubmit={handleSubmit}
        />
      )}
    </React.Fragment>
  );
};

export default FamilyMember;
